import { requestForApi } from "../../utils/httpUtil";
/**
 *  保存古树信息
 * @param params 古树信息实体对象
 * 返回操作成功与否
 */
export async function saveAncientInfo(params: APIGarden.AncientItem) {
  const res = await requestForApi("/api/v1/garden/ancients", {
    method:
      params?.id === undefined || params?.id === "" || params?.id === "0"
        ? "POST"
        : "PUT",
    data: params,
  });
  if (!res.result) {
    throw new Error(res.message);
  }
  return res.data;
}

/**
 *
 * @param id 根据ID拿到古树信息
 */
export async function queryAncientInfoById(id: string) {
  const res = await requestForApi(`/api/v1/garden/ancients/${id}`, {
    method: "GET",
  });
  if (!res.result) {
    throw new Error(res.message);
  }
  return res.data;
}

export async function queryDictionaryItemById(id: string) {
  const res = await requestForApi(`/api/v1/main/dictionarys/items/${id}`, {
    method: "GET",
  });
  if (!res.result) {
    throw new Error(res.message);
  }
  return res.data;
}
/**
 *
 * 获取植物对象
 */
export async function queryPlant() {
  const res = await requestForApi("/api/v1/garden/plants", {
    method: "GET",
  });
  if (!res.result) {
    throw new Error(res.message);
  }
  return res.data;
}

/**
 *
 * @param id 根据ID拿到植物对象
 */
export async function queryPlantById(id: string) {
  const res = await requestForApi(`/api/v1/garden/plants/${id}`, {
    method: "GET",
  });
  if (!res.result) {
    throw new Error(res.message);
  }
  return res.data;
}

// 查询路段信息列表数据
export async function queryRoad(id: string, current: number, pageSize: number) {
  const resp = await requestForApi(
    `/api/v1/garden/roads/search/${id}?pageSize=${pageSize}&current=${current}`,
    {
      method: "GET",
    }
  );

  if (resp.result) {
    return Promise.resolve({
      data: resp.data?.list,
      success: true,
      total: resp.data?.pagination?.total,
      pageSize: resp.data?.pagination?.pageSize,
      current: resp.data?.pagination?.current,
    });
  }
  return Promise.resolve({
    data: [],
    success: false,
    total: 0,
    pageSize: 20,
    current: 1,
  });
}
